import type { KeyboardEvent } from 'react'

/**
 * The keyboard's Next: Enter in one field of a form moves the cursor to the form's next field instead of submitting it
 * half filled. The field it is on says so with enterKeyHint="next".
 */
export function nextOnEnter(event: KeyboardEvent<HTMLInputElement>): void {
  if (event.key !== 'Enter' || event.nativeEvent.isComposing) return
  event.preventDefault()
  const fields = [...(event.currentTarget.form?.querySelectorAll<HTMLInputElement>('input:not([type="hidden"]):not(:disabled)') ?? [])]
  fields[fields.indexOf(event.currentTarget) + 1]?.focus()
}
